import { useMemo } from 'react';
import { MotionDiv } from '@/components/element/MotionDiv';
import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';

export const GenerateAfterCompletedAlert = () => {
  const { paymentTask: task } = useCurrentPaymentTask();

  const showAlert = useMemo(() => task!.generate_after_completed, [task]);

  if (showAlert) {
    return (
      <MotionDiv className="alert alert-warning text-white">
        <span className="alert-icon">
          <i className="fas fa-exclamation-triangle"></i>
        </span>
        <span className="alert-text text-sm">契約終了フェーズのプロジェクトから自動作成されたタスクです。</span>
      </MotionDiv>
    );
  } else {
    return null;
  }
};
